// PRODUCTION — live-updates empty / error placeholder.
import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { GSIcon, GSIconName } from 'src/components/shared/GSIcon'

const EmptyStateComponent = ({
  icon,
  title,
  subtitle,
}: {
  icon: GSIconName
  title: string
  subtitle: string
}) => {
  return (
    <div css={tw`flex flex-col items-center gap-2 px-4 py-10 text-center`}>
      <GSIcon iconName={icon} width={28} height={28} css={tw`fill-shades-300`} />
      <Typography variant="h6" css={tw`text-shades-700`}>
        {title}
      </Typography>
      <Typography variant="body2" css={tw`text-shades-400`}>
        {subtitle}
      </Typography>
    </div>
  )
}

export const EmptyState = memo(EmptyStateComponent)
